import { Provider } from '@vgtv/api-client';
import { formatPublishedDate } from '@vgtv/time-helpers';

import { getAssetProps } from '../../../helpers/getAssetProps';
import {
  getAssetAgeLimit,
  getSubscriptionLabel,
} from '../../../shared/helpers/assetHelpers';
import { config } from '../../../config';
import {
  formatDateAlternate,
  formatDurationLocalized,
} from '../../../utils/datetime';
import { AgeLimitLabel } from '../../AgeLimitLabel/AgeLimitLabel';

import type { SvpAssetAdditional } from '@vgtv/api-client/lib/svp_asset';
import type { ReactNode } from 'react';

export const getAssetLabels = (asset: SvpAssetAdditional) => {
  const { publishedDate, duration } = getAssetProps(asset);
  const ageLimit = getAssetAgeLimit(asset);
  const labels: ReactNode[] = [
    publishedDate &&
      (config.provider === Provider.AB
        ? formatDateAlternate(publishedDate)
        : formatPublishedDate(publishedDate, 'nb')),
    duration && formatDurationLocalized(duration),
    getSubscriptionLabel(asset),
    ![null, undefined].includes(ageLimit as any) && (
      <AgeLimitLabel ageLimit={ageLimit} />
    ),
  ];

  return labels.filter(Boolean);
};
